// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__EPb6y","text":"SelectPayment_text__1hwVx","title":"SelectPayment_title__wUT4n","btn":"SelectPayment_btn__2__9j"};